import { FC } from 'react';
import NavBar from 'components/NavBar';
import { Box } from '@chakra-ui/react';

const Layout: FC = ({ children }) => {
  return (
    <Box marginTop={'60px'}>
      <NavBar />
      {children}
    </Box>
  );
};

export default Layout;
